import { useDialogManager } from '@0x234/common-vue/composables/dialog-manager';
import { defineAsyncComponent } from 'vue';

// The openOtpDialog() function was initially part of AuthManager but has been extracted due to specific architectural
// constraints. The primary issue is from AuthManager's attempt to use the Vue Router and AuthStore simultaneously.
// Including the router led to an inject() warning, which occurs because the router's injection is outside a Vue
// component's setup() context and because the router instance is not yet available at the time the store is being
// initialized. While including AuthStore within AuthManager did not result in a direct circular dependency error, it
// introduced a circular import, which is considered poor practice. Extracting openOtpDialog() into a separate context
// resolves these challenges by avoiding direct dependency on the router within the store's initialization phase and
// mitigating the risk associated with circular imports, thereby ensuring a more robust and maintainable architecture.
// There might be a better way, or this might be addressed in future changes.

export function useOtpManager() {
    const dialogManager = useDialogManager();

    function openOtpDialog(authRequestJwt, email) {
        return dialogManager.openDialogComponent(
            defineAsyncComponent(() => import('components/OtpDialog.vue')),
            { authRequestJwt, email }
        );
    }

    return { openOtpDialog };
}
